import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Home from './pages/Home/Home';
import Dashboard from './pages/Dashboard/Dashboard';
import CmsGuard from './pages/Cms/CmsGuard';
import CmsList from './pages/Cms/CmsList';
import CmsEditor from './pages/Cms/CmsEditor';
import CmsPerformance from './pages/Cms/CmsPerformance';
import PresentationPage from './pages/Presentation/PresentationPage';
import ResultPage from './pages/Presentation/ResultPage';
import PropuestaPage from './pages/Presentation/PropuestaPage';
import { supabase } from './supabaseClient';

// Este componente actúa como "Guardia de Seguridad"
const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    // Obtener sesión actual
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Escuchar cambios de autenticación
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Mientras carga, mostrar loading
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-xl bg-gradient-to-br from-[#02214A] to-[#1717AF] animate-pulse" />
          <p className="text-slate-500 mt-4">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  // Si no hay sesión, redirigir al login
  if (!session) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default function App() {
  return (
    <Routes>
      {/* Ruta pública */}
      <Route path="/login" element={<Login />} />
      
      {/* Ruta donde aterriza n8n */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Home - Selección de módulos */}
      <Route 
        path="/home" 
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } 
      />
      
      {/* Dashboard Comercial */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      
      {/* Dashboard con lead específico (abre sidebar automáticamente) */}
      <Route 
        path="/dashboard/:cardId" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />

      {/* CMS Blog */}
      <Route
        path="/cms"
        element={
          <ProtectedRoute>
            <CmsGuard>
              <CmsList />
            </CmsGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cms/nuevo"
        element={
          <ProtectedRoute>
            <CmsGuard>
              <CmsEditor />
            </CmsGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cms/:id/performance"
        element={
          <ProtectedRoute>
            <CmsGuard>
              <CmsPerformance />
            </CmsGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cms/:id"
        element={
          <ProtectedRoute>
            <CmsGuard>
              <CmsEditor />
            </CmsGuard>
          </ProtectedRoute>
        }
      />

      {/* Presentación personalizada del lead (solo comerciales autenticados) */}
      <Route
        path="/presentation/:cardId"
        element={
          <ProtectedRoute>
            <PresentationPage />
          </ProtectedRoute>
        }
      />

      {/* Resultado público (solo lectura del recorrido generado) */}
      <Route path="/result/:version/:cardId" element={<ResultPage />} />

      {/* Propuesta comercial pública (landing enviada al lead) */}
      <Route path="/propuesta/:version/:cardId" element={<PropuestaPage />} />

      {/* Si entran a cualquier otro lado, mandar al home (el guardia decidirá si entran o no) */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}